import { render, staticRenderFns } from "./SelfBuild3D.vue?vue&type=template&id=6a0b8152&scoped=true&"
import script from "./SelfBuild3D.vue?vue&type=script&lang=js&"
export * from "./SelfBuild3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b8152",
  null
  
)

export default component.exports